module.exports = __webpack_public_path__ + "static/google-961c9a7beb0370c93ac4825e6f589473.png";